import React, { useEffect, useState } from 'react'

import { CFormInput, CFormLabel, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CPopover, CFormTextarea, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react'
import { Info, Plus } from 'lucide-react'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat'

const questionsWithInfo = [
  {
    question: 'History of Falling',
    info: ['No: score 0', 'Yes: score 15'],
    description: `<span>25 points for a fall in the present hospital admission or a recent fall.</span>`,
  },
  {
    question: 'Secondary Diagnoses',
    info: ['No: score 0', 'Yes: score 25'],
    description: `<span>15 points for more than one medical diagnosis.</span>`,
  },
  {
    question: 'Ambulatory Aid',
    info: ['Bedrest: score 0', 'Uses wheelchair: score 0', 'Nurse assist: score 0', 'Use of crutches, cane or walker: score 15', 'Ambulates holding onto the furniture: score 30'],
    description: `<span>0 points for no aid (nurse assist, bed rest, wheelchair), 15 points for crutches, cane, or walker, 30 points for grasping furniture for support to walk.</span>`,
  },
  {
    question: 'Intravenous Therapy',
    info: ['No: score 0', 'Yes: score 20'],
    description: `<span>20 points for an intravenous therapy or heparin lock.</span>`,
  },
  {
    question: 'Gait/Transferring',
    info: ['Independent: score 0', 'Shuffling gait/no assist: score 10', 'Bedridden or uses aid: score 20'],
    description: `<span>0 points for a normal gait, 10 points for a weak gait, 20 points for an impaired gait.</span>`,
  },
  {
    question: 'Mental Status',
    info: ['Can ambulate with no assistive devices or cannot due to limitation but understands: score 0', 'Uses assistive device or bedridden but says no issue ambulating: score 15'],
    description: `<span>0 points for being oriented to one's own ability.</span>`,
  },
]

const ProviderMorseCodeTreatment = ({ noteStructureRef, heading, showDataIfNoteIsFollowUp = true, showTreatmentAsAccordion, diagnosisName, scoreType, updateNoteStructure, type = 'note', setNoteRefTrigger, loggedUserProvider, changesInTreatmentShell, setChangesInTreatmentShell }) => {
  const today = new Date()
  const formattedDate = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`

  const [score, setScore] = useState('')
  const [date, setDate] = useState(formattedDate)
  const [visible, setVisible] = useState(false)
  const [scores, setScores] = useState([0, 0, 0, 0, 0, 0, 0])
  const [average, setAverage] = useState(0)

  const [modalVisible, setModalVisible] = useState(false)
  const [modalScores, setModalScores] = useState([0, 0, 0, 0, 0, 0])
  const [modalAverage, setModalAverage] = useState(0)
  useEffect(() => {
    if (noteStructureRef.current?.[scoreType]?.[diagnosisName]) {
      const existingData = noteStructureRef.current[scoreType][diagnosisName]
      console.log('existing data ', existingData)
      setScores(existingData.score || [0, 0, 0, 0, 0, 0, 0])
      setDate(existingData.date || '')
      if (existingData.score) {
        const total = existingData.score.slice(0, 6).reduce((sum, val) => sum + parseInt(val, 10), 0)

        console.log('total in use effect', total, existingData.score)

        setAverage(total)
      }
    }
  }, [diagnosisName, scoreType])

  useEffect(() => {
    if (noteStructureRef.current?.[scoreType]?.[diagnosisName]) {
      const existingData = noteStructureRef.current[scoreType][diagnosisName]
      noteStructureRef.current = {
        ...noteStructureRef.current,
        [scoreType]: {
          ...noteStructureRef.current[scoreType],
          [diagnosisName]: {
            ...existingData,
            finalScore: average || existingData.score[6],
          },
        },
      }
    }
  }, [diagnosisName, scoreType])

  console.log(noteStructureRef, 'noteStructureRef', diagnosisName, scoreType)

  console.log('notestructure ref in side score', noteStructureRef)
  const handleScoreChange = (newScores) => {
    updateNoteStructure(newScores, date, diagnosisName, scoreType)
    setNoteRefTrigger((prev) => prev + 1)
  }

  const handleDateChange = (e) => {
    const newDate = e
    setDate(newDate)
    updateNoteStructure(score, newDate, diagnosisName, scoreType)
    setNoteRefTrigger((prev) => prev + 1)
  }

  const handleChange = (index, value) => {
    const newScores = [...scores]
    newScores[index] = Number(value)
    // calculateAverage()
    // const total = newScores.reduce((sum, val) => sum + val, 0);
    const total = newScores.slice(0, 6).reduce((sum, val) => sum + parseInt(val, 10), 0)

    console.log('total', total, newScores)

    setAverage(total)
    setScores(newScores)
  }



  const handleModalScoreChange = (index, value) => {
    const newScores = [...modalScores]
    newScores[index] = Number(value || 0)
    setModalScores(newScores)
    const total = newScores.reduce((sum, val) => sum + val, 0)
    setModalAverage(total)
  }

  const handleModalSave = () => {
    const finalScores = [...modalScores, modalAverage]
    setScores(finalScores)
    setAverage(modalAverage)
    handleScoreChange(finalScores)
    setModalVisible(false)
  }

  const openModal = () => {
    const initial = scores.slice(0, 6)
    const total = initial.reduce((sum, val) => sum + Number(val || 0), 0)
    setModalScores(initial)
    setModalAverage(total)
    setModalVisible(true)
  }
  

  return (
    <>
      <CAccordion>
        <CAccordionItem className="border">
          <CAccordionHeader>
            <div className="d-flex align-items-center gap-2">
              <p className="p-0 m-0">Morse Score</p>
              {
                <CFormLabel
                  className="d-flex flex-column align-items-center mb-0 m-0 justify-content-center shadow "
                  onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    openModal()
                  }}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '20px',
                    background: '#4363F2',
                    cursor: 'pointer',
                  }}
                >
                  <Plus className="text-white" strokeWidth={2} size={15} />
                </CFormLabel>
              }
            </div>
          </CAccordionHeader>
          <CAccordionBody>
            {/* {<h7 style={{ fontSize: "14px" }}><b>{heading}</b></h7>} */}
            {console.log('showDataIfNoteIsFollowUp', showDataIfNoteIsFollowUp)}

            {/* {!showTreatmentAsAccordion &&
                <div>
                    <div className='d-flex align-items-center gap-2 '>
                        <div>
                            <b className=''>Morse Score </b>
                        </div>
                        <div className='mt-2'>
                            
                        </div>
                    </div>
                    <hr />
                </div>
            } */}

            {
              <div className="">
                {date && scores && (
                  <div className="d-5  ">
                    {showTreatmentAsAccordion ? (
                      <>
                        <div className="d-flex gap-2  ">
                          <div className=" d-flex gap-2">
                            <CFormLabel>
                              {' '}
                              <strong>Score : </strong>
                            </CFormLabel>
                            <p>{average || '-'}</p>
                          </div>
                          <div className="d-flex gap-2">
                            <CFormLabel>
                              {' '}
                              <strong>Date :</strong>
                            </CFormLabel>
                            <p type="date" value={date} onChange={(e) => handleDateChange(e, diagnosisName)} disabled={type === 'note' ? false : true} dateFormat="MM/dd/yyyy">
                              {date || '-'}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {/* <div className="d-flex gap-2 justify-content-center align-items-center" style={{ minWidth: '100px' }}>

                                    <CFormLabel>Score</CFormLabel>
                                    <CFormInput
                                        type="text"
                                        placeholder="Score"
                                        value={average}
                                        onChange={(e) => { handleManualAvg(e) }}
                                        disabled={type === "note" ? false : true}
                                    />
                                </div>
                                <div className="d-flex gap-2  justify-content-center align-items-center" style={{ minWidth: '100px' }}>
                                    <CFormLabel>Date</CFormLabel>
                                    <CFormInput
                                        type="date"
                                        value={date}
                                        onChange={(e) => handleDateChange(e, diagnosisName)}
                                        disabled={type === "note" ? false : true}
                                        dateFormat="MM/dd/yyyy"

                                    />
                                </div> */}
                        <div className="mb-3 w-100">
                          {/* <CFormLabel className="fw-medium">Summary</CFormLabel> */}
                          <div
                            style={{
                              fontSize: '14px',
                              // resize: "none",
                              backgroundColor: '#282828',
                              border: 'none',
                              color: 'white',
                            }}
                          >
                            <span>
                              Date: {new Date(date).toLocaleDateString('en-US')} <span style={{ marginLeft: '10px' }}>Morse Score: {average}</span>
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}

                <CModal backdrop="static" size="lg" visible={modalVisible} onClose={() => setModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel" scrollable>
                  <CModalHeader
                    style={{
                      backgroundColor: '#282828',
                      borderBottom: '1px solid gray',
                      color: 'white',
                      display: 'flex',
                      justifyContent: 'center',
                      position: 'relative', // allows absolute positioning
                    }}
                  >
                    <CModalTitle
                      style={{
                        color: 'white',
                        textAlign: 'center',
                        width: '100%',
                      }}
                      id="StaticBackdropExampleLabel"
                    >
                      Morse Score
                    </CModalTitle>
                  </CModalHeader>

                  <CModalBody
                    style={{
                      backgroundColor: '#282828',
                      color: 'white',
                    }}
                  >
                    <div className="px-4 py-3" style={{ fontFamily: 'Segoe UI, sans-serif' }}>
                      <div className="mb-4">
                        <div className="d-flex align-items-center gap-3 " style={{ width: '40%' }}>
                          <CFormLabel className="fw-medium mb-0">Date:</CFormLabel>

                          <CustomDatePickingFormat
                            type="date"
                            value={date}
                            onChange={(e) => handleDateChange(e, diagnosisName)}
                            disabled={type === 'note' ? false : true}
                            style={{
                              width: '180px',
                              height: '32px',
                              fontSize: '14px',
                              padding: '4px 8px',
                            }}
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(1, 1fr)',
                          gap: '20px',
                          background: '#282828',
                        }}
                        className="w-100"
                      >
                        {questionsWithInfo.map((item, index) => {
                          return (
                            <div className="shadow-sm   p-4 h-100 rounded-2 w-100">
                              <div className="d-flex align-items-center gap-1">
                                <p
                                  style={{
                                    fontSize: '14px',
                                  }}
                                  className="p-0 m-0"
                                >
                                  {index + 1} : {item.question}
                                </p>
                                <div className=" ">
                                  {/* <CPopover content={infoTexts[index]} placement="right" trigger="hover">
                                    <CButton
                                      style={{
                                        lineHeight: 'normal',
                                      }}
                                      className="p-0 m-0"
                                      color="none"
                                      size="sm"
                                    >
                                      <Info size={16} />
                                    </CButton>
                                  </CPopover> */}
                                </div>
                              </div>
                              <span className="d-flex p-1  align-items-start gap-1 " style={{ color: 'yellow' }} dangerouslySetInnerHTML={{ __html: item.description }} />

                              <CFormInput
                                type="text"
                    min={0}
                    value={modalScores[index] === 0 ? '0' : modalScores[index]}
                    onChange={(e) => handleModalScoreChange(index, e.target.value)}
                    onFocus={(e) => {
                      if (e.target.value === '0' || e.target.value === 0) {
                        e.target.value = ''
                        handleModalScoreChange(index, '')
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value === '' || e.target.value === null) {
                        handleModalScoreChange(index, 0)
                      }
                    }}
                                style={{
                                  width: '200px',
                                  marginTop: '10px',
                                  height: '30px',
                                  fontSize: '13px',
                                  padding: '4px 6px',
                                  color: 'white',
                                  background: '#282828',
                                }}
                              />
                            </div>
                          )
                        })}
                      </div>

                      {/* <div className="row">
                                    {questions.map((label, index) => (
                                        <div className="col-md-6 mb-4" key={index}>
                                            <div className="bg-secondary rounded p-3 shadow-sm h-100">
                                                <div className='d-flex     '>
                                                    <CFormLabel className="fw-semibold d-flex align-items-start " style={{ fontSize: "14px" }}>
                                                        {label}

                                                    </CFormLabel>
                                                    <div className=' ' style={{ marginTop: '-3px' }} >
                                                        <CPopover
                                                            // style={{ fontSize: "12px" }}
                                                            content={infoTexts[index]}
                                                            placement="right"
                                                            trigger="hover"
                                                        // className="ms-2"
                                                        >
                                                            <CButton
                                                                color="none"
                                                                size="sm"
                                                                className="ms-1 p-0"
                                                                style={{ height: "18px" }}
                                                            >
                                                                <Info size={16} />
                                                            </CButton>
                                                        </CPopover>
                                                    </div>
                                                </div>

                                                <CFormInput
                                                    type="number"
                                                    min={0}
                                                    value={scores[index]}
                                                    onChange={(e) => handleChange(index, e.target.value)}
                                                    onFocus={(e) => {
                                                        if (e.target.value === "0") e.target.value = "";
                                                    }}
                                                    onBlur={(e) => {
                                                        if (e.target.value === "") handleChange(index, 0);
                                                    }}
                                                    style={{
                                                        width: "90px",
                                                        height: "30px",
                                                        fontSize: "13px",
                                                        padding: "4px 6px",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div> */}

                      {/* Average Display */}
                      <div className="text-center mt-4 pt-2 border-top">
                        <h6 className="fw-semibold text-white">
                          Total Score: <span className=" ">{modalAverage}</span>
                        </h6>
                      </div>
                    </div>
                  </CModalBody>

                  <CModalFooter
                    style={{
                      backgroundColor: '#282828',
                      borderTop: '1px solid gray',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                    className="pt-2"
                  >
                    <CButton
                      style={{
                        backgroundColor: '#333',
                        border: '1px solid gray',
                        color: 'white',
                        borderRadius: '6px',
                        padding: '8px 20px',
                      }}
                      variant="outline"
                      color="secondary"
                      onClick={() => setModalVisible(false)}
                    >
                      Close
                    </CButton>
                    <CButton
                      style={{
                        backgroundColor: '#4363F2',
                        border: 'none',
                        color: 'white',
                        borderRadius: '6px',
                        padding: '8px 20px',
                      }}
                      variant="outline"
                      color="primary"
                      onClick={handleModalSave}
                    >
                      Save
                    </CButton>
                  </CModalFooter>
                </CModal>
              </div>
            }
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
    </>
  )
}

export default ProviderMorseCodeTreatment
